import React from 'react';
import { Box, Typography } from '@mui/material';

const DashboardHeader = ({ title, description }) => {
    if (!title) return null;

    return (
        <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography 
                variant="h3" 
                component="h1" 
                sx={{ 
                    fontWeight: 500,
                    mb: description ? 2 : 0,
                    color: 'text.secondary'
                }}
            >
                {title}
            </Typography>
            {description && (
                <Box sx={{ maxWidth: '900px', mx: 'auto' }}>
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            fontSize: '16px',
                            color: 'text.secondary'
                        }}
                    >
                        {description}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default DashboardHeader; 